import { render, staticRenderFns } from "./WithdrawCash.vue?vue&type=template&id=22fefa7a"
import script from "./WithdrawCash.vue?vue&type=script&lang=js"
export * from "./WithdrawCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports